<template>
  <span
    v-if="updatedAt"
    class="text-static-default-low flex shrink-0 items-center justify-end gap-4 py-6"
  >
    {{ i18n(translations.caption) }}

    <RevTooltip>
      <template #trigger="{ show, hide }">
        <IconInfo
          class="inline"
          size="16"
          @focusin="show"
          @focusout="hide"
          @mouseleave="hide"
          @mouseover="show"
        />
      </template>

      {{ tooltipText }}
    </RevTooltip>
  </span>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevTooltip } from '@ds/components/Tooltip'
import { IconInfo } from '@ds/icons/IconInfo'

import { AI_SUMMARY_REVIEW_COUNT_THRESHOLD } from '../../aiSummary.constants'

import translations from './AIInfo.translations'

const i18n = useI18n()

const { updatedAt, reviewsCount } = defineProps<{
  updatedAt?: string | null
  reviewsCount?: number | null
}>()

const formattedUpdatedAt = computed(() => {
  if (!updatedAt) return ''

  return i18n.date(new Date(updatedAt))
})

const tooltipText = computed(() => {
  if (!reviewsCount) return ''
  if (reviewsCount > AI_SUMMARY_REVIEW_COUNT_THRESHOLD) {
    return i18n(translations.tooltip, {
      updateDate: formattedUpdatedAt.value,
    })
  }
  if (reviewsCount === AI_SUMMARY_REVIEW_COUNT_THRESHOLD) {
    return i18n(translations.tooltipLatestReviews, {
      number: AI_SUMMARY_REVIEW_COUNT_THRESHOLD,
      updateDate: formattedUpdatedAt.value,
    })
  }

  return i18n(translations.tooltipAllReviews, {
    updateDate: formattedUpdatedAt.value,
  })
})
</script>
